import {
  ApiError,
  Auth as SharedAuth,
  type LoginRequest,
  type RegisterRequest,
} from '@rh/shared/services/auth-service'

import { Track } from './track'

function syncTrackingFromResponse(response: {
  user: { id: string; email: string; name?: string; fullName?: string }
}) {
  const { user } = response
  void Track.identify({
    id: user.id,
    email: user.email,
    name: user.fullName ?? user.name ?? user.email,
  })
}

async function signin(request: LoginRequest) {
  const response = await SharedAuth.signin(request)
  syncTrackingFromResponse(response)
  return response
}

async function signup(request: RegisterRequest) {
  const response = await SharedAuth.signup(request)
  // signup requests do not return active tokens, so avoid identify() to
  // prevent attaching a logged-out browser session to a verified account.
  return response
}

async function verifyEmail(token: string) {
  const response = await SharedAuth.verifyEmail(token)
  if (response.user) {
    syncTrackingFromResponse({ user: response.user })
  }
  return response
}

function signout() {
  SharedAuth.signout()
  void Track.identify()
  void Track.setAgency()
}

const Auth = {
  ...SharedAuth,
  signin,
  signup,
  verifyEmail,
  signout,
}

export { ApiError, Auth }
export type { LoginRequest, RegisterRequest }
